import { render, staticRenderFns } from "./NewAutoShareOnInstagramModal.vue?vue&type=template&id=4959d4b8&scoped=true&"
import script from "./NewAutoShareOnInstagramModal.vue?vue&type=script&lang=js&"
export * from "./NewAutoShareOnInstagramModal.vue?vue&type=script&lang=js&"
import style0 from "./NewAutoShareOnInstagramModal.vue?vue&type=style&index=0&id=4959d4b8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4959d4b8",
  null
  
)

export default component.exports